import { useState, useCallback } from 'react';
import { signInWithGoogle, signOut } from '@/services/authService';
import { useAuthContext } from '@/context/AuthContext';

export function useAuth() {
  const { user, loading, authError, setAuthError } = useAuthContext();
  const [signingIn, setSigningIn] = useState(false);

  const login = useCallback(async () => {
    setSigningIn(true);
    setAuthError(null);
    try {
      await signInWithGoogle();
    } catch (err) {
      setAuthError(err);
      throw err;
    } finally {
      setSigningIn(false);
    }
  }, [setAuthError]);

  const logout = useCallback(async () => {
    await signOut();
  }, []);

  return { user, loading, signingIn, authError, login, logout };
}
